/* Open Shopify's existing consent dialog; never set consent on the visitor's behalf. */
if (!customElements.get('zk-cookie-preferences')) {
  customElements.define('zk-cookie-preferences', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      button.addEventListener('click', async () => {
        status.hidden = true;
        button.disabled = true;
        try {
          if (typeof window.privacyBanner?.showPreferences !== 'function') {
            throw new Error('Shopify privacy banner unavailable');
          }
          await window.privacyBanner.showPreferences();
        } catch (error) {
          status.textContent = 'Cookieindstillingerne kunne ikke åbnes. Genindlæs siden og prøv igen.';
          status.hidden = false;
        } finally {
          button.disabled = false;
        }
      });
    }
  });
}
